import { forwardRef, type PropsWithChildren } from "react";

import { cn } from "$/lib/utils/functions/misc.functions";

import { Tab } from "../../atoms";
import type { TabsProps } from "./Tabs.types";

const Tabs = forwardRef<HTMLDivElement, PropsWithChildren<TabsProps>>(
  (
    { type = "basic", tabs, activeTab, handleTabChange, className },
    forwardedRef,
  ) => {
    return (
      <div
        ref={forwardedRef}
        className={cn("w-fit rounded-lg shadow-md", className)}
      >
        <div
          className={cn({
            "flex rounded-lg bg-gray-200 px-2 py-1.5 transition duration-200 hover:bg-gray-200":
              type === "bordered",
          })}
        >
          <nav
            className={cn("flex", { "gap-x-1": type === "basic" })}
            aria-label="Tabs"
            role="tablist"
            aria-orientation="horizontal"
          >
            {tabs.map((tab) => (
              <Tab
                tabType={type}
                tabObject={tab}
                isActive={activeTab === tab.id}
                onTabChange={handleTabChange}
              />
            ))}
          </nav>
        </div>
      </div>
    );
  },
);

Tabs.displayName = "Tabs";

export default Tabs;
